import styled from 'styled-components'
import Banner from '../../assets/blog/banner.png'
import SpaceHeroBanner from '../../assets/blog/decor_aqua2_medium.png'
import PostBanner from '../../assets/blog/posts/Imagenes-Blog1-1200x439.png'

export const BlogBanner = styled.section`
  display: flex;
  width: 100%;
  height: 90vh;
  background: url(${Banner}) top center no-repeat;
  background-size: cover;
`;

export const BlogBannerContent = styled.div`
  position: relative;
  width: 100%;
  max-width: 1090px;
  margin: 0 auto;

  div {
    position: absolute;
    width: 535px;
    left: 0px;
    bottom: -120px;
    padding: 31px 90px;
    background-color: #0a3941;
    text-align: left;

    a {
      font-size: 0px;
      img {
        width: 233px;
      }
    }

    h2 {
      font-family: DomaineSansText-Medium;
      font-size: 35px;
      line-height: 1.31;
      letter-spacing: -0.91px;
      color: #93da49;
    }
    p {
      color: #fff;
      font-size: 16px;
      line-height: 1.69;
    }
  }
`;

export const SpaceHero = styled.div`
  position: relative;
  width: 100%;
  height: 200px;
  background-image: url(${SpaceHeroBanner});
  background-repeat: no-repeat;
  background-position-x: -75px;
  background-position-y: -415px;
  background-size: 1180px;
  z-index: -1;
`;

export const TitleGeral = styled.h2`
  color: #93da49;
  font-size: 90px;
  line-height: 0.64;
  text-align: center;
  font-family: FeltThatW01-Regular;
  margin-bottom: 20px;

  span {
    display: block;
    color: #8a9ba5;
    font-size: 20px;
    font-family: DomaineSansText-BoldItalic;
    margin-top: 40px;
  }
`;

export const Post = styled.section`
  position: relative;
  display: flex;
  height: 370px;
  max-width: 122rem;
  margin-right: 0;
  margin-left: auto;
  margin-top: 80px;
  justify-content: flex-end;

  .post--content {
    width: 30%;
    max-width: 109rem;
    min-width: 293px;
    text-align: left;
    margin: 33px 20px;

    h2 {
      color: #007e78;
      font-size: 30px;
      line-height: 1.67;
      font-family: DomaineSansText-Medium;
      margin-bottom: 20px;
    }
    p {
      color: #8a9ba5;
      font-size: 15px;
      line-height: 1.47;
      margin-bottom: 15px;
    }
    a {
      display: inline-block;
      color: #fff;
      font-size: 17px;
      font-weight: normal;
      line-height: 1.18;
      letter-spacing: -0.56px;
      background: #009f67;
      padding: 11px 26px;
      border-radius: 8px;
      text-decoration: none;

      &:hover {
        background: #007e78;
      }
    }
  }

  .post--banner {
    width: 767px;
    height: auto;
    background-image: url(${PostBanner});
    background-repeat: no-repeat;
    background-size: cover;
    flex-shrink: 0;
  }
`;